
import { Content } from '@/models/news-detail';
import { Component, Prop, Vue } from 'vue-property-decorator';
@Component({})
export default class BlocksContentComponent extends Vue {
  @Prop() content!: Array<Content>;
}
